"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesMaker = void 0;
var lodash_1 = require("lodash");
var PropertiesMaker = /** @class */ (function () {
    function PropertiesMaker() {
    }
    PropertiesMaker.merge = function (src, props) {
        return Object.assign((0, lodash_1.cloneDeep)(src), (0, lodash_1.cloneDeep)(props));
    };
    return PropertiesMaker;
}());
exports.PropertiesMaker = PropertiesMaker;
